import { dataset, findMany, on } from '../helpers';
import { mapDefaults, whenReady } from './google-maps';

class Map {
    constructor(element) {
        this.element = element;
        this.init();
    }

    async init() {
        try {
            const { Map } = await google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
            const data = dataset(this.element, 'map');
            const position = new google.maps.LatLng(data.lat, data.lng);

            const customMarker = document.createElement('img');

            customMarker.src = '/images/maps/marker.svg';
            customMarker.width = 33;
            customMarker.height = 43;

            const mapOptions = {
                center: position,
                ...mapDefaults,
            };
            const map = new Map(this.element, mapOptions);

            return new AdvancedMarkerElement({
                map,
                content: customMarker,
                position,
                title: data.title,
            });
        } catch (error) {
            console.error(`Error initializing: ${error}`);
        }
    }
}

const initMaps = () => {
    whenReady('[data-map]', () => {
        findMany('[data-map]').forEach(element => new Map(element));
    });
};

const init = () => {
    on('load', initMaps, window);
    on('htmx:afterSwap', initMaps, window);
};

init();
